import { Input } from '@builder.io/sdk';

import moleculeAwardsFields from 'molecules/Awards/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const splitContentSectionFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Main heading for this section (title and optional subtitle).',
  },
  imageField('image'),
  {
    name: 'awardItems',
    type: 'object',
    subFields: moleculeAwardsFields(),
    helperText: 'Optional awards or recognitions to highlight in this section.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const splitContentSectionConfig = {
  name: 'SplitContentSection',
  inputs: splitContentSectionFields,
};

export type SplitContentSectionConfigProps = GenerateBuilder<typeof splitContentSectionFields>;

export default splitContentSectionConfig;
